import { useState, createContext, useContext, useEffect } from "react";
import { UserService } from "../services/UserService";
import { authProvider } from "../models/authentication/authProvider";
import { routePaths } from "../constants/routePaths";
import { useLocation, useNavigate } from "react-router-dom";
import { useLazyGetUserInfoQuery } from "../services/rtkQueryServices/userService";
import { dataStore } from "../constants/dataStore";
const AuthContext = createContext<authProvider | null>(null);

export const AuthProvider = (props: any) => {
  const [isLoggedIn, setIsLoggedIn] = useState<any>(UserService.isLoggedIn);
  const [getUserInfo] = useLazyGetUserInfoQuery();
  const [userInfo, setUserInfo] = useState<any>(null);
  const [isLoadingUserInfo, setIsLoadingUserInfo] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setIsLoggedIn(UserService.isLoggedIn);
  }, []);

  const logOut = (navigateToLogin: boolean = true) => {
    setIsLoggedIn(false);
    localStorage.removeItem(dataStore.isLoggedIn);
    setUserInfo(null);
    setIsLoadingUserInfo(false);
    UserService.logOut(navigateToLogin);
  };

  const logIn = () => {
    UserService.login();
    setIsLoggedIn("true");
    navigate(routePaths.base, { state: { from: routePaths.login } });
    updateUserInfo();
  };

  useEffect(() => {
    if (
      isLoggedIn === "true" &&
      !userInfo &&
      location.pathname !== routePaths.register
    ) {
      getUserInfo(null).then((res) => {
        if (res.data?.isSuccess) {
          setUserInfo({
            email: res.data?.data?.email,
            organizationId: res.data?.data?.organizationId,
            role: res.data?.data?.roleName,
            exp: res.data?.data?.TokenExpirationTime,
            userName: res.data?.data?.userName,
            userId: res.data?.data?.userId,
          });
          UserService.subscriptionId = res.data?.data?.subscriptionId;
        }
        setIsLoadingUserInfo(false);
      });
    }
  }, []);

  const updateUserInfo = () => {
    getUserInfo(null).then((res: any) => {
      if (res.data?.isSuccess) {
        setUserInfo({
          email: res.data?.data?.email,
          organizationId: res.data?.data?.organizationId,
          role: res.data?.data?.roleName,
          exp: res.data?.data?.TokenExpirationTime,
          userName: res.data?.data?.userName,
          userId: res.data?.data?.userId,
        });
      }
      setIsLoadingUserInfo(false);
    });
  };

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        authClaims: userInfo,
        logOut,
        logIn,
        isLoading: isLoadingUserInfo,
      }}
    >
      {props?.children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
